<template>
	<div class="nav-buttons-block">
		<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Need Help?</h1>
		<v-base-nav-page :links="links">
		</v-base-nav-page>
		<v-base-nav-links contact-only></v-base-nav-links>
	</div>
</template>

<script>
	import axios from 'axios';
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './components/BaseNavPage';
	import BaseNavLinks from './components/BaseNavLinks';


	export default {
		name: "HelpMain",

		components: {
			'v-base-nav-page': BaseNavPage,
			'v-base-nav-links': BaseNavLinks
		},

		data() {
			return {
				links: [
					{to: 'help_with_my_order', caption: 'I need help with my order'},
					{to: 'general_questions', caption: 'I need help placing a new order / General Questions'},
				]
			};
		},
		mounted(){
			this.checkZendeskStatus();
		},
		methods:{
			checkZendeskStatus(){
				let self = this;
				axios
					.get("/service/customer_help/rest/index.php/customer_help/is_zendesk_enabled")
					.then(function (response) {
						if (response.status === 200 && response.data.data === true && response.data['status'] === 'success') {
							self.waitForCookieBanner();
						}
					});
			},
			waitForCookieBanner(){
				if (document.getElementsByClassName('cookie-info-ui-container').length > 0) {
					setTimeout(this.waitForCookieBanner, 1500);
				}
				else {
					if (document.getElementById('ze-snippet')) return; // was already loaded
					let scriptTag = document.createElement("script");
					scriptTag.src = "https://static.zdassets.com/ekr/snippet.js?key=29d6896b-2972-48fd-b256-85f9622fa9d9";
					scriptTag.id = "ze-snippet";
					document.getElementsByTagName('head')[0].appendChild(scriptTag);
					window.zESettings = {
						webWidget: {
							chat: {
								title: {
									'*': 'TextbookX Support',
								},
								departments: {
									select: "TextbookX Support: Tier 1",
									enabled: []
								},
								concierge: {
									avatarPath: '',
									name: 'TextbookX',
									title: { '*': 'Online Bookstore Customer Support' }
								}
							}
						}
					};
				}
			}
		}
	}
</script>

<style scoped>

</style>
